export default "build/assets/logo-c336d92561d647ac.png"